/* aa-cut-defer.js  -  r-cutdefer, 13 Sep 2026
   ---------------------------------------------------------------------------
   WHAT IT DOES
   The collection tables used to render the whole AluCut shell inside every
   product row - on the angles page that was 56 copies, 8,803 elements and
   1,411 form controls, all of them display:none until somebody clicks. The
   section now emits an EMPTY panel row plus ONE <template>. This file clones
   the template into a row the first time that row's cut button is clicked.

   Measured on a 16-core desktop before the change, timing exactly the markup
   that moved: 142ms to parse and build, 521ms to attach, style and lay out.
   About 7KB on the wire - brotli already ate the repetition. THE WIN IS CPU,
   NOT BANDWIDTH, and on a mid-range phone it is several times the desktop cost.

   WHY A CAPTURE LISTENER, AND WHY THAT MEANS THE 182KB TABLE FILE IS UNTOUCHED
   aa-cut-table-<family>.js handles the toggle with a DELEGATED (bubbling)
   listener, and on open it already calls aaBuildCutFinishSelect(row) and
   aaRefreshCartCache(row). A listener registered with capture=true on document
   runs BEFORE that handler. So: we build the panel, then their handler runs
   against a fully-populated panel and fills it exactly as it always did.
   Nothing in the table file changes. That file is IIFE-wrapped, so none of its
   functions are reachable from here anyway - which is precisely why the panel
   has to exist before their code looks at it, not after.

   The share-link restore path calls toggle.click() - a real DOM click - so it
   comes through here too. Verified in the minified live asset, not assumed.

   THE PART THAT COULD COST MONEY IF IT WERE WRONG
   Nothing in the table JS ever sets the offcut radios' name attribute; the
   Liquid was the only thing making each pair unique. One shared template would
   therefore put every row into ONE radio group, and "keep my offcuts" would
   land on a different product's cart line - reaching the customer's checkout
   page and their confirmation email. So the names are rewritten ON THE
   FRAGMENT, BEFORE it is attached to the document: there is never a moment
   when two rows share a radio name.

   FAIL-SAFE: every step is guarded and the whole build runs inside try/catch.
   If the template is missing this does nothing and throws nothing.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var BUILT = 'data-aa-built';

  function templateFor(panelRow) {
    var scope = panelRow.closest ? panelRow.closest('[id^=collection-table-]') : null;
    return (scope && scope.querySelector('template.aa-cut-shell-tpl')) ||
           document.querySelector('template.aa-cut-shell-tpl');
  }

  /* Same lookup the table JS uses: by handle first, DOM position as the fallback. */
  function panelRowFor(row) {
    if (!row) return null;
    var handle = row.getAttribute('data-handle') || '';
    if (handle) {
      var byHandle = document.querySelector('.aa-cut-panel-row[data-aa-for="' + handle + '"]');
      if (byHandle) return byHandle;
    }
    var next = row.nextElementSibling;
    return next && next.classList && next.classList.contains('aa-cut-panel-row') ? next : null;
  }

  function build(panelRow) {
    if (!panelRow || panelRow.getAttribute(BUILT) === '1') return false;
    var cell = panelRow.querySelector('td');
    if (!cell || cell.firstElementChild) return false;      /* already has content */
    var tpl = templateFor(panelRow);
    if (!tpl || !tpl.content) return false;

    var frag = tpl.content.cloneNode(true);

    /* --- per-product fixups, ON THE FRAGMENT, before it is attached --- */
    var pid = panelRow.getAttribute('data-aa-pid') ||
              panelRow.getAttribute('data-aa-for') || '';
    var radios = frag.querySelectorAll('.aa-cut-offcut-checkbox');
    for (var i = 0; i < radios.length; i++) radios[i].name = 'aa-offcut-' + pid;

    var note = panelRow.getAttribute('data-aa-minnote') || '';
    if (note) {
      var minEl = frag.querySelector('.aa-cut-note-min');
      if (minEl) minEl.textContent = note;
    }

    cell.appendChild(frag);
    panelRow.setAttribute(BUILT, '1');
    return true;
  }

  function ensureFromToggle(target) {
    if (!target || !target.closest) return;
    build(panelRowFor(target.closest('tr')));
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('aa-cut-toggle')) return;
    try { ensureFromToggle(t); } catch (err) {
      if (window.console && console.warn) console.warn('[aa-cut-defer]', err);
    }
  }, true);   /* CAPTURE - must run before the table's delegated handler */

  /* Escape hatch for tests and for any surface that opens a panel without a click. */
  window.aaBuildCutPanel = function (rowOrPanel) {
    if (!rowOrPanel) return false;
    var pr = rowOrPanel.classList && rowOrPanel.classList.contains('aa-cut-panel-row')
             ? rowOrPanel : panelRowFor(rowOrPanel);
    try { return build(pr); } catch (err) { return false; }
  };
})();
